export default __webpack_public_path__ + "static/media/logo.a45e1a7f.png";